import React, { useState, useEffect } from "react";
import { Layout, Input, Skeleton } from "antd";
import "./index.scss";
import _ from "lodash"; // 引入lodash来使用_.debounce
import axiosInstance from "@/axios/axiosInstance";
const gongjvj = [
  { key: 1, value: "AI文本工具" },
  { key: 2, value: "AI设计工具" },
  { key: 3, value: "AI视频工具" },
  { key: 4, value: "AI对话工具" },
  { key: 5, value: "AI编程工具" },
  { key: 6, value: "AI音频工具" },
  { key: 7, value: "AI翻译工具" },
  { key: 8, value: "AI内容工具" },
  // { key: 9, value: "AI提醒工具" },
  // { key: 10, value: "AI模型工具" },
  // { key: 11, value: "AI开发工具" },
  // { key: 12, value: "思维导图" },
  // { key: 13, value: "AI写作" },
  // { key: 14, value: "表格数据处理" },
];
function transformData(data) {
  const typeMap = new Map(gongjvj.map((item) => [item.key, item.value]));

  const groupedData = data.reduce((acc, item) => {
    const type = item.type;
    if (type !== null && typeMap.has(type)) {
      const title = typeMap.get(type);
      const group = acc.find((group) => group.type === type);
      if (group) {
        group.children.push(item);
      } else {
        acc.push({ type, title, children: [item] });
      }
    }
    return acc;
  }, []);

  return groupedData;
}

// 示例调用
const ToolGallery = () => {
  const [toolData, setToolData] = useState([]);
  const [toolFl, setFl] = useState(1);
  // const [toolList, setTool] = useState(gongjvj);

  const clickFl = (v) => {
    setFl(v.key);
    const filteredData = toolData.filter((group) => group.type === v.key);
    const remainingData = toolData.filter((group) => group.type !== v.key);
    setToolData([...filteredData, ...remainingData]);
  };
  useEffect(() => {
    getToolData();
    document.title =
      "渐风AI,AI工具集,AI绘画,AI视频,AI绘画,AI翻译,AI音频,AI写作,AI编程,AI工具中心";
  }, []);
  const getToolData = async (title) => {
    try {
      const response = await axiosInstance.get(
        `/tools/index/list?page=1&limit=400&title=${title || ""}`
      );
      const filteredData = transformData(response.data.data).filter(
        (group) => group.type === toolFl
      );
      const remainingData = transformData(response.data.data).filter(
        (group) => group.type !== toolFl
      );
      setToolData([...filteredData, ...remainingData]);
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };
  const debouncedFetchData = _.debounce(getToolData, 1000);
  const handleChange = (e) => {
    debouncedFetchData(e.target.value);
  };
  return (
    <div>
      <Layout className="toollist">
        <div className="toollist-hea">
          <div className="name">AI工具集</div>
          <Input
            placeholder="搜索"
            style={{ width: "300px", marginTop: "16px" }}
            onChange={handleChange}
            allowClear
          />
        </div>
        <div className="tool-cont">
          <div className="name_fl" id="name_fl">
            {gongjvj.map((v) => {
              return (
                <div
                  key={v.key}
                  className={`fl ${toolFl === v.key ? "check" : ""}`}
                  onClick={() => clickFl(v)}
                >
                  {v.value}
                </div>
              );
            })}
          </div>
          <div direction="vertical" className="vertical">
            {!toolData.length ? (
              <Skeleton />
            ) : (
              toolData.map((v, index) => {
                return (
                  <>
                    <div className="chuzsz_name">{v.title}</div>
                    {v.children.length > 0 && (
                      <div key={index} className="chuzsz">
                        {v.children.map((item, index) => {
                          return (
                            <a
                              href={item.redirectUrl}
                              className="cont-san"
                              key={item.toolsId}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <div className="cont-l">
                                <img src={item.cover} alt="" />
                              </div>
                              <div className="cont-r">
                                <div className="title">{item.name}</div>
                                <div className="name" title={item.introduction}>
                                  {item.introduction}
                                </div>
                              </div>
                            </a>
                          );
                        })}
                      </div>
                    )}
                  </>
                );
              })
            )}
          </div>
        </div>
      </Layout>
    </div>
  );
};

export default ToolGallery;
